


  // components/TermsAndConditions.jsx
  import React from "react";
  import { useNavigate } from "react-router-dom";
  import { ArrowLeft, FileText, AlertCircle, Loader2 } from "lucide-react";
  import { usePageData } from "../../../hooks/useProfilePageData";

  const TermsAndConditions = () => {
    const { pageData, loading, error } = usePageData("terms-and-conditions");
    const navigate = useNavigate();

    const formatDescription = (text) => {
      if (!text) return null;
      
      return text.split("\n").map((line, index) => (
        <React.Fragment key={index}>
          {line}
          <br />
        </React.Fragment>
      ));
    };

    if (loading) {
      return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
          <div className="text-center">
            <Loader2 className="w-12 h-12 text-blue-600 animate-spin mx-auto mb-4" />
            <p className="text-gray-600 text-lg">Loading terms & conditions...</p>
          </div>
        </div>
      );
    }

    if (error) {
      return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
          <div className="text-center bg-white rounded-lg shadow-lg p-8 max-w-md">
            <AlertCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Error</h2>
            <p className="text-gray-600">{error}</p>
            <button
              onClick={() => navigate(-1)}
              className="mt-6 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Go Back
            </button>
          </div>
        </div>
      );
    }

    if (!pageData) {
      return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
          <div className="text-center">
            <FileText className="w-16 h-16 text-gray-400 mx-auto mb-4" />
            <p className="text-gray-600">Page not found</p>
            <button
              onClick={() => navigate(-1)}
              className="mt-4 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Go Back
            </button>
          </div>
        </div>
      );
    }

    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
        <div className="container mx-auto px-4 py-8">
          <div className="mb-8 flex items-center">
            <button
              onClick={() => navigate(-1)}
              className="inline-flex items-center gap-2 px-4 py-2 text-gray-700 bg-white rounded-lg hover:bg-gray-100 transition-all duration-200 shadow-sm hover:shadow-md"
            >
              <ArrowLeft className="w-5 h-5" />
            </button>

            <h1 className="flex-1 text-center text-xl sm:text-4xl font-bold text-gray-800">
              Terms and Conditions
            </h1>

            <div className="w-[90px]" />
          </div>

          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="px-6 sm:px-8 py-8 prose prose-lg max-w-none">
              <div className="text-gray-700 leading-relaxed space-y-2">
                {formatDescription(pageData.description)}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  export default TermsAndConditions;